import React from 'react'
import classNames from 'classnames'

const Spacing = ({type}) => {
  return (
    <div 
    className={classNames(
      {
        'cge-spacing--small' : type === 'sm',
        'cge-spacing--compact' : type === 'ct' ,
        'cge-spacing--moderate' : type === 'md' ,
        'cge-spacing--normal' : type === 'nl' ,
        'cge-spacing--grand' : type === 'gn' ,
        'cge-spacing--ex-grand' : type === 'mg' ,
        'cge-spacing--larg' : type === 'lg',
      }
    )}>
    </div>
  )
}

export default Spacing